import { COLORS_CLASSIC_DARK, COLORS_CLASSIC_LIGHT } from "@ali/we-colors";

/**
 * 明亮模式颜色
 */
export var COLORS_LIGHT = COLORS_CLASSIC_LIGHT;

/**
 * 暗黑模式颜色
 */
export var COLORS_DARK = COLORS_CLASSIC_DARK;